import { render, staticRenderFns } from "./Creditos.vue?vue&type=template&id=3117c2a1"
import script from "./Creditos.vue?vue&type=script&lang=js"
export * from "./Creditos.vue?vue&type=script&lang=js"
import style0 from "./Creditos.vue?vue&type=style&index=0&id=3117c2a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports